<div class="w-100">
  <nav class="navbar navbar-top">
    <div class="nav-left col-6 row p-0">
      <div class="top-select col-6 p-0">
        <app-flag-select [options]="countryList" optionLabel="description" optionValue="id" [(ngModel)]="selectedCountries" (changed)="onCountryChange($event)" class="first-select" [filter]="false" [showClear]="false" [showCountry]="false"/>

        <p-select [options]="entityList" optionLabel="description" optionValue="id" [(ngModel)]="selectedEntity"
          class="second-select entity-select" (onChange)="onEntityChange($event.value)" [showClear]="false">
          <ng-template pTemplate="selectedItem" let-option>
            <span class="entity-selected">
              <i class="icon entity-icon"></i>
              <span class="entity-text">{{ option?.description }}</span>
            </span>
          </ng-template>
        </p-select>

      </div>
      <div class="nav-item search col-4 p-0">
        <input pInputText type="text" [id]="'navSearch'" [name]="'navSearch'" placeholder="{{'SEARCH' | translate}}" [(ngModel)]="searchValue" (keydown.enter)="onGlobalSearch()" (ngModelChange)="onSearchChange()" />
        @if(searchValue && searchValue.length > 0) {
          <i class="icon close-icon" (click)="clearGlobalSearch()"></i>
        }
        <i class="icon search-icon" (click)="onGlobalSearch()"></i>
      </div>
    </div>

    <div class="nav-right col-6 p-0">
      <div class="nav-item">
        <p-select [options]="languageList" optionLabel="description" optionValue="id" [(ngModel)]="selectedLanguage" class="second-select" (onChange)="onLanguageChange()" appendTo="body" [showClear]="false"/>
      </div>

      <p-divider layout="vertical"></p-divider>

      <div class="nav-item" (click)="toggleNotif($event)">
        <i class="pi pi-bell"></i>
        @if(unreadCount() > 0){
          <div class="new-dot"></div>
        }
      </div>
      <div class="notification">
        <p-popover #notif [dismissable]="true" [style]="{'width': '20%'}">
          <div class="notif-header">
            <h6>{{'NOTIFICATIONS' | translate}} 
              @if(unreadCount() > 0){
                <span>({{unreadCount()}})</span>
              }
            </h6>
          </div>

          <p-divider class="header-divider"></p-divider>

          <div class="notif-content">
            @for(n of unreadNotifications(); track $index){
              <div class="content" [ngClass]="{'clickable': n.notificationType === 'REQUEST' || n.title === 'IMPORT'}" (click)="clikNotif(n.id); $event.stopPropagation()">
                <div class="notif-icon">
                  <i class="pi pi-bell"></i>
                </div>

                <div class="notif-word">
                  <p class="title mb-1" [ngClass]="{'font-bold': !n.isRead}">{{n.title | translate}}</p>
                  <p class="word mb-1">{{stripHtml(n.body) | translate : {'0': getRefType(n.notificationRefType) | translate} }}</p>
                  <p class="time">{{n.createdAt | timeAgo}}</p>
                </div>

                <div class="red-dot"></div>
              </div>

              @if(!$last){
                <p-divider class="my-1"></p-divider>
              }
            }

            @if(unreadCount() == 0){
              <p class="no-notif">{{'NO_NEW_NOTIFICATIONS' | translate}}</p>
            }
          </div>

          <p-divider class="my-2"></p-divider>

          <app-button type="primary" label="{{'VIEW_ALL_NOTIFICATION' | translate}}" class="logout-button"
            (click)="goToNotification()" />
        </p-popover>
      </div>

      <p-divider layout="vertical"></p-divider>

      <div class="nav-item">
        <i class="icon more-apps-icon"></i>
      </div>

      <p-divider layout="vertical"></p-divider>

      <div class="nav-item avatar" (click)="toggleProfile($event)">
        @if(accDetails?.profileImage){
          <img [src]="accDetails?.profileImage" alt="Profile" />
        }@else{
          <span>{{ accDetails?.firstName.charAt(0) }}</span>
        }
      </div>
      <div class="pop">
        <p-popover #op appendTo="body" [dismissable]="true">
          <div class="account-header">
            <div class="avatar">
              @if(accDetails?.profileImage){
              <img [src]="accDetails?.profileImage" alt="Profile" />
              }@else{
              <span>{{ accDetails?.firstName.charAt(0) }}</span>
              }
            </div>
            <div class="user-info">
              <p class="user-name">{{accDetails?.fullName}}</p>
              <p class="user-id">{{accDetails?.userCode}}</p>
            </div>
          </div>

          <p-divider class="my-2"></p-divider>
          <p-menubar [model]="menus" class="mb-2 profile-menubar" />
          <app-button type="secondary" label="{{'LOGOUT' | translate}}" class="logout-button" (clicked)="logout()" />
        </p-popover>
      </div>
    </div>
  </nav>

  @if(!hideNavbar){
  <nav class="navbar navbar-bottom">
    <div class="nav-left">
      @if(router.url === '/account-settings'){
      <div class="page-header">
        <div class="page-block">
          <div class="row align-items-center">
            <div class="col-md-12 px-2">
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <a [routerLink]="['/dashboard']">
                    <i class="icon home-icon"></i>
                  </a>
                </li>

                <div class="breadcrumb-i">
                  <i class="pi pi-chevron-right"></i>
                </div>

                <li class="breadcrumb-item">
                  <span>{{'ACC_SETTINGS' | translate}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      }@else if(router.url === '/notifications'){
      <div class="page-header">
        <div class="page-block">
          <div class="row align-items-center">
            <div class="col-md-12 px-2">
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <a [routerLink]="['/dashboard']">
                    <i class="icon home-icon"></i>
                  </a>
                </li>

                <div class="breadcrumb-i">
                  <i class="pi pi-chevron-right"></i>
                </div>

                <li class="breadcrumb-item">
                  <span>{{'NOTIFICATIONS' | translate}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      }@else{
      <app-breadcrumb></app-breadcrumb>
      }
    </div>

    <div class="nav-right">
      <div class="nav-item">
        <span class="mr-3">
          {{'LOCAL_TIMEZONE' | translate}}:
          <img [src]="localTimeZone.country?.code | flag" />
          {{ localTimeZone?.localTime }} ({{ localTimeZone?.offset }})
        </span>
        <span>
          {{'COUNTRY_TIMEZONE' | translate}}:
          @if ((jwtService.countryFlagCode$ | async) === 'GLOBE') {
            <img [src]="'MY' | flag" />
          }
          @else {
            <img [src]="(jwtService.countryFlagCode$ | async) | flag" />
          }
          {{ countryTimeZone?.localTime }} ({{ countryTimeZone?.offset }})
        </span>
      </div>
    </div>
  </nav>
  }
</div>